import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { isIE } from 'react-device-detect';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { FirebaseContextProvider } from './firebase/provider';
import './icons/library';
import './styles/App.scss';
import { App } from './App';
import { NoApp } from './NoApp';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <FirebaseContextProvider>{isIE ? <NoApp /> : <App />}</FirebaseContextProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
